// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class AccountingSystemTransactionsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'accountingSystemTransactions';
        this.Server =
            this.props.context.getState().server.accountingSystemTransactions;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['fromAccount.name', 'toAccount.name', 'note'];

        const defaultHead = [
            {
                id: 'fromAccountId',
                label: 'fromAccount',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                object: 'fromAccount',
                from: 'accountingSystemAccounts',
                displayGrid: true
            },
            {
                id: 'toAccountId',
                label: 'toAccount',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                object: 'toAccount',
                from: 'accountingSystemAccounts',
                displayGrid: true
                // check error, required
            },
            {
                id: 'amountFrom',
                label: 'fromAccountAmount',
                alignRight: true,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'amountTo',
                label: 'toAccountAmount',
                alignRight: true,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'note',
                label: 'note',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true
            },
            {
                id: 'url',
                label: 'url',
                alignRight: false,
                cell: 'Url',
                displayGrid: true
            },
            {
                id: 'paymentDate',
                label: 'paymentDate',
                alignRight: false,
                cell: 'Date',
                default: 'today',
                displayGrid: true,
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName',
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated',
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
